import router from './router'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {getToken, getMenus,removeMenus} from '@/utils/auth'

const whiteList = ['/login'];  // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  var sessionId = localStorage.getItem('sessionId');
	if (sessionId != 'undefined' && getMenus()) {
	    if (to.path === '/login') {
	      next({path: '/welcome'});
	      NProgress.done() // if current page is welcome will not trigger	afterEach hook, so manually handle it
	    } else {
	      next();
	    }
	} else {
	    if (whiteList.indexOf(to.path) !== -1) {
	      next()
	    } else {
	      removeMenus();
	      next('/login');
	      NProgress.done();
	    }
	}
  // next();
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});




// WEBPACK FOOTER //
// ./src/permission.js